export default {
    path: "/mail-parser",
    component: () => import("~/pages/mail-parser/index.vue"),
    children: [
        {
            path: "",
            component: () => import("~/pages/mail-parser/lista.vue"),
            meta: {
                requiresAdmin: true,
            },
        },
        {
            path: "editar/:id",
            component: () => import("~/pages/mail-parser/editar.vue"),
            meta: {
                requiresAdmin: true,
            },
        },
        {
            path: "novo",
            component: () => import("~/pages/mail-parser/editar.vue"),
            meta: {
                requiresAdmin: true,
            },
        },
    ],
}